import React, { useEffect, useState } from "react";
import { format } from "date-fns";
import { getSummaries } from "../../services";
import _ from "lodash";
import moment from "moment";
import { useSelector } from "react-redux";

export default function DashSummaryHistory() {
  const [summaries, setSummaries] = useState([]);
  const userProfile = useSelector((state) => state.user);

  const fetchMessage = async () => {
    try {
      const today = moment().format('YYYY-MM-DD');
      const last7Days = moment().subtract(7, 'days').format('YYYY-MM-DD');
      const response = await getSummaries(
        userProfile.userinfo.Id,
        last7Days,
        today,
        0,
        5
      );
      setSummaries(response?.data?.Result?.SummaryList);
    } catch (err) {
      console.error("Error fetching summaries:", err);
    }
  };

  useEffect(() => {
    fetchMessage();
  }, []);

  return (
    <div className="mt-1 xl:w-[40%] lg:w-[60%] md:w-full w-full relative group/dashboard-summary-history h-[460px]">
      <div
        className="absolute inset-0 bg-gradient-to-r from-blue-600/40 via-indigo-600/40 to-blue-600/40 rounded-2xl blur-sm opacity-50 group-hover/dashboard-summary-history:opacity-80 transition duration-500 pointer-events-none"
        aria-hidden="true"
      />
      <div className="relative h-full overflow-hidden flex flex-col bg-white/70 dark:bg-black/40 backdrop-blur-3xl rounded-2xl border-2 border-blue-500/20 dark:border-blue-400/20 shadow-[0_15px_35px_-10px_rgba(0,0,0,0.4)]">
        <div className="px-4 py-3 border-b border-gray-200 dark:border-blue-500/10 flex-shrink-0">
          <h2 className="text-lg font-semibold text-gray-900 dark:text-white">Summary History</h2>
          <p className="text-sm text-gray-500 dark:text-gray-400">Recent activity summaries</p>
        </div>

        <div className="flex-1 overflow-y-auto px-4 py-3
          [&::-webkit-scrollbar]:w-1.5
          [&::-webkit-scrollbar-track]:rounded-full
          [&::-webkit-scrollbar-track]:bg-gray-100
          [&::-webkit-scrollbar-thumb]:rounded-full
          [&::-webkit-scrollbar-thumb]:bg-gray-300
          dark:[&::-webkit-scrollbar-track]:bg-gray-900
          dark:[&::-webkit-scrollbar-thumb]:bg-blue-gray-900"
        >
          {!_.isEmpty(summaries) ? (
            <div className="space-y-3">
              {[...summaries]
                .sort((a, b) => {
                  const ad = new Date(a?.SummaryDate);
                  const bd = new Date(b?.SummaryDate);
                  return bd - ad; // Descending: latest first
                })
                .map((msg, index) => {
                const formattedDate = format(new Date(msg.SummaryDate), "dd/MM/yyyy");
                const isToday = moment(msg.SummaryDate).isSame(moment(), 'day');

                return (
                  <div
                    key={`${msg?.SummaryDate || "NA"}-${index}`}
                    className="group relative rounded-xl border border-blue-500/15 bg-white/70 p-3.5 transition-all duration-200
                      dark:border-blue-400/20 dark:bg-white/[0.04] dark:backdrop-blur-sm
                      hover:border-blue-500/30 hover:bg-white dark:hover:border-blue-400/35 dark:hover:bg-white/[0.08]
                      hover:shadow-[0_0_12px_rgba(59,130,246,0.12)]"
                  >
                    <div className="flex items-start justify-between gap-4">
                      <div className="min-w-0 flex-1">
                        <p className="text-sm leading-relaxed text-gray-800 dark:text-gray-100">
                          {msg.Summary}
                        </p>
                        <div className="mt-2 flex items-center">
                          <span className="text-xs font-medium text-gray-500 dark:text-gray-400/90">
                            {isToday ? '' : formattedDate}
                          </span>
                          {isToday && (
                            <span className="inline-flex items-center rounded-full border border-blue-400/30 bg-blue-500/10 px-2 py-0.5 text-xs font-medium text-blue-700 dark:border-blue-400/25 dark:bg-blue-500/15 dark:text-blue-300">
                              <span className="mr-1 h-1 w-1 rounded-full bg-blue-500 shadow-[0_0_6px_rgba(59,130,246,0.8)]" />
                              Today
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="text-center py-8">
              <div className="text-gray-500 dark:text-gray-400">
                <svg className="w-6 h-6 mx-auto mb-2 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                </svg>
                <p className="text-sm font-medium">No summaries available</p>
                <p className="text-xs text-gray-400 dark:text-gray-500 mt-1">
                  Recent summaries will appear here
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
